exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face{font-family:Font1;src:url(" + require("./fonts/Font1.ttf") + ")}@font-face{font-family:Font2;src:url(" + require("./fonts/Font2.ttf") + ")}@font-face{font-family:Font3;src:url(" + require("./fonts/Font3.ttf") + ")}@font-face{font-family:Font4;src:url(" + require("./fonts/Font4.ttf") + ")}@font-face{font-family:Font5;src:url(" + require("./fonts/Font5.ttf") + ")}.signature-generator .App{text-align:center;display:flex;flex-direction:column;justify-content:center;align-items:center}.signature-generator .Select{width:100px;text-align:left}.signature-generator .button{width:100px}.signature-generator .signature-container{display:flex;flex-direction:column;justify-content:center;align-items:center}.signature-generator .footer-container{display:flex;padding:2px 0px;align-items:center;justify-content:space-between}.signature-generator .footer-container .Select{height:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/reusableComponents/AutoGenerateSignature/autoGenerateSignature.scss
// module id = 1729
// module chunks = 0